import styled from 'styled-components';
import { Div } from 'styles';

export const CartItem = styled(Div)`
  color: ${({ theme }) => theme.white};

  background: radial-gradient(
      158.48% 294.91% at 50% 320.96%,
      rgba(255, 0, 122, 0.2) 0%,
      rgba(255, 0, 122, 0) 100%
    ),
    linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1));

  border: 1px solid ${({ theme }) => theme.gray}4c;
  margin-bottom: 10px;
  padding: 20px 30px;
`;

export const RadioButton = styled.input.attrs({ type: 'radio' })`
  appearance: none;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.gray}4c;
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 0.1),
    rgba(255, 255, 255, 0.1)
  );
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:checked {
    /* Change border color when checked */
  }

  /* Inner dot when checked */
  &:checked::before {
    content: '';
    width: 14px; /* Smaller than the radio button */
    height: 14px;
    border-radius: 50%;
    background: ${({ theme }) => theme.blue};
    position: absolute;
  }
`;
